import { getApiClient } from './apiClient';
let marketplaceSearchBase = 'marketplace-search/v1';
export const setMarketplaceSearchBase = base => {
  marketplaceSearchBase = base;
};
export function searchAssets(query) {
  return getApiClient().post(`${marketplaceSearchBase}/assets/search`, {
    data: query
  }).then(res => [res]);
}